import {createSlice} from '@reduxjs/toolkit';

import {getEventFacilityBreakdown} from './event-facility-breakdown-actions';
import {eventFacilityBreakdownAdapter} from './event-facility-breakdown-adapters';

export interface EventFacilityBreakdownState {
    error: boolean;
    isLoading: boolean;
    results: ReturnType<typeof eventFacilityBreakdownAdapter.getInitialState>;
    meta: {
        totalCount: number;
        nextOffset: number | null;
        limit: number;
        offset: number;
    };
}

export const initialState: EventFacilityBreakdownState = {
    error: false,
    isLoading: false,
    results: eventFacilityBreakdownAdapter.getInitialState(),
    meta: {
        totalCount: 0,
        nextOffset: 0,
        limit: 0,
        offset: 0,
    },
};

const eventFacilityBreakdownSlice = createSlice({
    name: 'events/event-facility-breakdown',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEventFacilityBreakdown.pending, (state) => {
                state.isLoading = true;
                state.error = false;
            })
            .addCase(
                getEventFacilityBreakdown.fulfilled,
                (state, {payload}) => {
                    eventFacilityBreakdownAdapter.setAll(
                        state.results,
                        payload.data.results
                    );

                    state.meta = payload.meta;
                    state.isLoading = false;
                }
            )
            .addCase(getEventFacilityBreakdown.rejected, (state) => {
                state.isLoading = false;
                state.error = true;
            });
    },
});

export default eventFacilityBreakdownSlice.reducer;
